import axios from 'axios';

import { buildUrl, getHeaders } from '../helpers';
import * as resources from '../resources';

class AppraisalApi {
  getAppraisalDetailsForImpersonation = appraisalId => {
    const url = `${buildUrl(resources.GetAppraisalByAppraisalId)}/${appraisalId}`;
    return axios.get(url, getHeaders());
  };
}

export default AppraisalApi;
